<!--资源预览 Sag 2020-04-21-->
<template>
  <div class="its-preview">
    <!--预览的头部-->
    <div class="pre-view-header">
      <div class="its-header">
        <div class="its-title fl">
          <!-- <p ></p> -->
          <div>
            <p class="its-type-icon small-file-icon" :class="[previewRaw.mime]"></p>
          </div>
          <el-tooltip effect="dark" :content="previewRaw.title" placement="bottom">
            <span>{{previewRaw.title}}</span>
          </el-tooltip>
        </div>
      </div>
      <i class="its-icon its-close its-icon-close-layer" @click="closePreview" data-io-click="tracker"></i>
    </div>
    <div ref="previewContainer" class="its-preview-bottom" :class="[previewRaw.mime]">
      <ts-preview class="its-preview-container" :params="previewParams" @load-action="loadAction" ref="preview"></ts-preview>
    </div>
  </div>
</template>
<script>
import {getRequest} from '../../../../utils/http'
export default {
  name: 'Preview',
  data () {
    return {
      editAble: false
    }
  },
  props: {
    previewRaw: {
      type: Object,
      default: function () {
        return {}
      }
    },
    previewParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.startPreview()
  },
  methods: {
    startPreview: function () {
      //启动预览
      this.$refs.preview.loadData()
    },
    loadAction: function (action) {
      getRequest(action.url, action.params).then(function (resp) {
        action.requestCallback(resp)
      })
    },
    closePreview: function () {
      if (this.fatherAction) {
        this.fatherAction({type:'close'})
      }
    }
  }
}
</script>
<style>
.its-preview-bottom.mp3 .its-preview-container {
  /* position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  margin-top: -56px; */
}
.its-preview-bottom.mp3 .its-preview-container .ts-ali-player {
  width: 700px;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  height: calc(100% - 150px);
  top: 68px;
  margin-top: 0px;
}
</style>
<style scoped>
.its-preview {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2000;
  background: #EAEEF1;
}

.pre-view-header {
  position: fixed;
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.03);
  z-index: 200;
  left: 0;
  top: 0;
}

.pre-view-header .its-header {
  width: 62.5%;
  margin: 0 auto;
  height: 100%;
  line-height: 80px;
}

.its-close {
  position: absolute;
  right: 28px;
  font-size: 18px;
  top: 31px;
  color: #BEBEBE;
  cursor: pointer;
}

.its-close:hover {
  color: #2695FF;
}

.its-right {
  position: relative;
}

.its-right i {
  margin-right: 35px;
  color: #BEBEBE;
  cursor: pointer;
  font-size: 25px;
}

.its-right i:hover {
  color: #2695FF;
}

.its-right i.disabled,
.its-right i.disabled:hover {
  opacity: 0.3;
  color: #BEBEBE;
  cursor: default;
}

.its-preview-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 80px;
  background: white;
  text-align: center;
  overflow-y: auto;
  width: 1200px;
  margin: 0 auto;
}
.its-preview>>>.ts-preview-header {
  display: none;
}
.its-option-page {
  font-size: 16px;
  color: white;
  margin-left: 20px;
  color: #888888;
}

.its-option-page .its-current {
  color: #333333;
}

.its-option-page i {
  color: #BEBEBE;
  cursor: pointer;
}

.its-option-page i:hover {
  color: #2695FF;
}

.hidden-btn {
  visibility: hidden;
}

.its-title {
  display: inline-block;
  max-width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}

.its-title span {
  color: #333333;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.its-title div {
  position: absolute;
  left: -14px;
  top: 3px;
}

.its-title > span {
  margin-left: 35px;
}

.small-file-icon {
  transform: scale(0.5);
  -ms-transform: scale(0.5);
}

.its-home-preview >>> .its-resource-list {
  z-index: 3000;
}

.its-resource-preview {
  margin-top: 50px;
}

.its-home-preview >>> .its-resource-list {
  height: calc(100% - 80px);
  margin-top: 80px;
}

.its-home-preview >>> .office-view {
  height: calc(100vh - 80px);
}

.its-preview >>> .ts-preview-content {
  width: 1200px;
}
.its-preview >>> .ts-li-image {
  width: 100%;
}

.ie-browser .ts-base-btn {
  line-height: 32px;
}
</style>
